import React from "react"
import styled from '~/ui/styled'
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import MessageTime from "./message-time"

const Container = styled.View`
  flex-direction: column;
   width: auto;
`

const Content = styled.View`
  width: auto;
  height: auto;
  padding: 10px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`

const Text = styled.Text<{byMe: boolean}>`
  display: block;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
`

// 开奖消息
export const GameNoticeMessage: React.FC<MessageProps & { content?: string }> = observer(
  ({ message, content }) => {
    return (
      <Container>
        <Content>
            <Text byMe={message.byMe}>{content || message.content}</Text>
            {/* <Text>时间：{formatDate(message.created, "s")}</Text> */}
        </Content>
        <MessageTime time={message.created} />
      </Container>
        
    ) 
  },
)

export const WrappedGameNoticeMessage: React.FC<MessageProps & { content?: string }> = (props) => {
  return props.message.byMe ? (
    <MessageSent {...props} Component={GameNoticeMessage} isNoBg={true} />
  ) : (
    <MessageReceived {...props} Component={GameNoticeMessage} isNoBg={true} />
  )
}
export default WrappedGameNoticeMessage
